import { render, staticRenderFns } from "./ProductComparison.vue?vue&type=template&id=0cef5952&scoped=true&"
import script from "./ProductComparison.vue?vue&type=script&lang=js&"
export * from "./ProductComparison.vue?vue&type=script&lang=js&"
import style0 from "./ProductComparison.vue?vue&type=style&index=0&id=0cef5952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cef5952",
  null
  
)

export default component.exports